<template>
<div>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" :md="12" :sm="12" class="mt-3">
        <LanguageCard
          class="mb-6"
          @setLanguage="setLanguage"
          :type="[POST_TYPE_VLOG, POST_TYPE_COACH]"
        />
      </v-col>
      <v-col cols="12">
        <h1 class="primary--text font-weight-bold text-md-h5 text-h6">{{ $gettext("Latest VLOG / Coaching video") }}</h1>
      </v-col>
      <v-col cols="12" :md="8" :sm="7" class="mt-5 createPostBtnWrapper">
        <PostList
          ref="postList"
          :key="languageDefault"
          :action="'post/getPostVlogAndCoach'"
          :language="languageDefault"
        />
      </v-col>
      <v-col cols="12" :md="4" :sm="5" class="lastedColumn pl-3">
        <LatestReviewCard />
        <LatestVlogCard />
      </v-col>
    </v-row>

  </v-container>
</div>
</template>

<script>
import PostService from "@/services/PostService";
import LanguageCard from "@/components/Card/LanguageCard";
import LatestReviewCard from "@/components/Card/LatestReviewCard";
import LatestVlogCard from "@/components/Card/LatestVlogCard";
import PostList from "@/components/Post/PostList";
export default {
  name: 'Vlogger',
  async mounted() {
    this.$store.commit("setCourseDetail", {});
    const vlog = await this.getListData(this.page, this.limit, POST_TYPE_VLOG)
    this.vlogList = (vlog && vlog.list) || []
    const coach = await this.getListData(this.page, this.limit, POST_TYPE_COACH)
    this.coachList = (coach && coach.list) || []
  },
  data () {
    return {
      showDialog: false,
      currPic: null,
      showPhotoPage: false,
      showVideoPage: false,
      vlogList: [],
      coachList: [],
      page: 1,
      limit: 10
    }
  },
  components: {LanguageCard, LatestReviewCard, LatestVlogCard, PostList},
  computed: {
    vloggers() {
      return this.$store.state.vlogger.vloggers
    },
    languageDefault: {
      get() {
        return this.$store.state.post.languageDefaultVlog;
      },
      set(value) {
        this.$store.commit("post/setDefaultLanguageVlog", value);
      },
    },
  },
  methods: {
    async getListData(page = 1, limit = 10, type = POST_TYPE_VLOG) {
      return await PostService.getPostList({
        filter_type: [type],
        sort_desc: "createdDate",
        page,
        limit,
      });
    },
    metaObj(meta) {
      const res = Array.isArray(meta) ? {} : meta
      return res
    },
    setLanguage(list) {
      this.$refs.postList.onLoadPost()
    },
  },
}
</script>

